import { axiosInstance } from '@/resources/requestInfo';
import { feedbackRoutes } from '@/redux/feedback/routes';

export async function feedbackEmail({ message }: { message: string }): Promise<void> {
  try {
    await axiosInstance.post(feedbackRoutes.FEEDBACK, {
      text: message,
    });
  } catch (error: any) {
    console.error('Ошибка отправки feedback email:', error);
  }
}
